import {useRef, useEffect, useState} from 'react';
import errorImageAsset from '../assets/errorImageLoading.svg';
import ErrorImage from '../assets/errorImageLoading.svg?react'

export function ImageWrapper({image, alt, display, mode, width, height, backgroundColor, margin, padding, borderRadius, transition = true, loadDelay, onLoad}) {
    const imageRef = useRef(null);
    const [isLoadingImage, setIsLoadingImage] = useState(true);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [usingErrorImage, setUsingErrorImage] = useState(false);

    useEffect(() => {
        const element = imageRef ? imageRef.current : null;
        if (element) {
            element.onload = () => {
                if (image) {
                    setTimeout(() => {
                        setIsLoadingImage(false);
                        setImageLoaded(true);
                        if (onLoad) onLoad(true, image);
                    }, loadDelay * 1000);
                } else {
                    setTimeout(() => {
                        setIsLoadingImage(false);
                        setImageLoaded(false);
                        if (onLoad) onLoad(false, image);
                    }, loadDelay * 1000);
                }
            };
            element.onerror = () => {
                setTimeout(() => {
                    setIsLoadingImage(false);
                    setImageLoaded(false);
                    if (onLoad) onLoad(false, image);
                }, loadDelay * 1000);
            };
            element.src = image;
        }
    }, []);

    useEffect(() => {
        const element = imageRef ? imageRef.current : null;
        if (element) {
            if (!isLoadingImage && !imageLoaded) {
                element.src = getNoImage();
                setUsingErrorImage(true);
            } else if (!isLoadingImage && imageLoaded) {
                if (!element.src.includes(getNoImage()))
                    setUsingErrorImage(false);
            }
        }
    }, [isLoadingImage, imageLoaded]);

    useEffect(() => {
        const element = imageRef ? imageRef.current : null;
        const newImage = image;
        const oldImage = element ? element.src : null;
        if (newImage !== oldImage) {
            setIsLoadingImage(true);
            setTimeout(() => {
                if (element) {
                    element.src = newImage;
                } else {
                    setIsLoadingImage(false);
                    setImageLoaded(true);
                    if (onLoad) onLoad(true, image);
                }
            }, loadDelay * 1000);
        }
    }, [image]);

    const getNoImage = () => {
        return errorImageAsset;
    };

    const getSize = () => {
        return {width: width, height: height};
    };

    const containerStyle = () => {
        const size = getSize();
        return {
            position: 'relative',
            display: display || 'block',
            margin: margin || 'unset',
            padding: 'unset',
            width: size.width || 30,
            height: size.height || 30
        };
    };

    const imageStyle = () => {
        const size = getSize();
        return {
            width: size.width || 30,
            height: size.height || 30,
            objectFit: mode || 'cover',
            transform: `scale(${isLoadingImage ? 0 : 1})`,
            borderRadius: borderRadius || 0,
            transition: transition ? 'transform 0.2s ease' : 'unset',
            padding: padding ? padding : 0,
            background: backgroundColor || 'unset',
            display: 'block',
            boxSizing: 'border-box',
            margin: '0 auto',
            opacity: usingErrorImage ? 0 : 1
        };
    };

    const errorImageStyle = () => {
        return {
            width: '100%',
            height: '100%',
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
        };
    };

    return (
        <div style={containerStyle()}>
            {usingErrorImage ? (
                <div style={errorImageStyle()}>
                    <ErrorImage alt="Error loading image" data-original-url={getNoImage()}/>
                </div>
            ) : null}
            <img ref={imageRef} alt={alt} style={imageStyle()} draggable={false} crossOrigin={image?.includes('firebasestorage.googleapis.com') ? 'anonymous' : undefined}/>
        </div>
    );
}